import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';


export default function SoilCompositionSearch({ substrates, onSelect, canAdd=true }) {
    const [value, setValue] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [newComposition, setNewComposition] = React.useState('');

    const handleDialogOpen = () => {
        setOpen(true);
    };

    const handleDialogClose = () => {
        setOpen(false);
    };

    const handleDialogSave = () => {
        setValue(newComposition);
        onSelect(newComposition, true);
        setOpen(false);
        setNewComposition('');
    };

    return (
        <>
            <Autocomplete
                fullWidth
                value={value}
                onChange={(event, newValue) => {
                    // if null then return
                    if (!newValue) return;
                    if (typeof newValue === 'string') {
                        setValue(newValue);
                        onSelect(newValue);
                    } else if (newValue && newValue.inputValue) {
                        handleDialogOpen();
                    } else {
                        setValue(newValue);
                        onSelect(newValue);
                    }
                }}
                filterOptions={(options, params) => {
                    const filtered = options.filter((composition) => {
                        const input = params.inputValue.toLowerCase();
                        return composition.toLowerCase().includes(input);
                    });

                    const { inputValue } = params;
                    const isExisting = options.includes(inputValue);
                    if (inputValue !== '' && !isExisting && canAdd) {
                        filtered.push(inputValue);
                        // filtered.push(`Add "${inputValue}"`);
                    }

                    return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={substrates}
                renderOption={(props, option) => (
                    <li {...props}>{option}</li>
                )}
                freeSolo
                renderInput={(params) => <TextField {...params} label="Enter soil substrate..." />}
            />

            <Dialog open={open} onClose={handleDialogClose}>
                <DialogTitle>Add New Soil Composition</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Composition"
                        value={newComposition}
                        onChange={(event) =>
                            setNewComposition(event.target.value)
                        }
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Cancel</Button>
                    <Button
                        onClick={handleDialogSave}
                        color="primary"
                        variant="contained"
                        disabled={!newComposition}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
